module.exports = __webpack_public_path__ + "static/media/product32.38272b58.jpg";